'use client'
import tailwindConfig from '@tailwind.config'
import Image from 'next/image'

const LoadingCard = ({ imageWidth = 300, imageHeight = 200 }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };


    return (
        <div className={`sm:w-[${imageWidth}px] w-full sm:h-[438px] border-cream shadow-sm hover:shadow-md duration-300 h-full overflow-hidden rounded-sm`}

        >
        <Image
            className='sm:w-[300px] w-full aspect-[4/3] rounded-sm overflow-hidden'
            src={'/images/loader.jpg'}
            width={imageWidth}
            height={imageHeight}

        />

                    <div className='sm:w-[300px] w-full p-2'>
                        <div width={imageWidth} className='text-xl font-semibold text-maincolor relative flex flex-col justify-between sm:overflow-hidden sm:h-[75px] h-full'>
                            <div className='flex flex-col gap-1 sm:h-[55px] h-full'>
                                <div className='flex h-6 bg-maincolor/30 rounded-sm animate-pulse items-center justify-center'></div>
                                <div className='flex h-6 bg-maincolor/30 rounded-sm animate-pulse items-center justify-center'></div>
                                {/* <div className='sm:flex hidden h-6 bg-maincolor/30 rounded-md animate-pulse items-center justify-center'></div> */}
                            </div>
                        </div>
                        <div className='flex flex-col w-full gap-2 sm:mt-1 mt-1'>
                                <div className='w-1/2 flex h-6 bg-third/70 rounded-sm animate-pulse items-center justify-center'></div>
                                <div className='w-2/3 flex h-4 bg-maincolor/30 rounded-sm animate-pulse items-center justify-center'></div>
                        </div>
                        <div className='w-full pb-1 mb-1'>
                        </div>
                        <div className='flex flex-col w-full gap-2'>
                            <div className='flex flex-row gap-2 w-full'>
                                <div className='flex w-2/3 h-4 bg-maincolor/30 rounded-sm animate-pulse items-center justify-center'></div>
                            </div>
                            <div className='flex flex-row gap-2 w-full'>
                                <div className='flex w-1/2 h-4 bg-gray-300 rounded-sm animate-pulse items-center justify-center'></div>
                            </div>
                        </div>
                    </div>
        </div>
    )
}

export default LoadingCard